// removed by extract-text-webpack-plugin
module.exports = {"pageContainer":"Header-module__pageContainer___Il1hh","brandLogo":"Header-module__brandLogo___1e1gl","brandName":"Header-module__brandName___1TRyT","brandNavbar":"Header-module__brandNavbar___2moZr"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Header/Header.module.css
// module id = 630
// module chunks = 0